import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button, Divider } from "antd";
import "./candidateDescription.scss";
import Evaluations from "../Evaluations";
import EvaluationSetup from "../evaluationSetup";
import EvalCandidateTableSelectable from "../EvalCandidateTableSelectable";
import useResumeStore from "../../store/resume.store";
import EvaluationsBank from "../EvaluationsBank";

const communicationListTable = [
  "Select",
  "Sr. No.",
  "Resume ID",
  "Name",
  "Email",
  "Phone",
  "Candidate Status",
  "Link Shared On",
  "Num Resent",
  "Link Status",
  "Eval Status",
  "Updated On",
  "Updated By",
];
const examListTable = [
  "Select",
  "Sr. No.",
  "Resume ID",
  "Name",
  "Email",
  "Phone",
  "Candidate Status",
  "Proctoring Status",
  "Evaluation Status",
  "Evaluation Date",
  "Updated On",
  "Updated By",
];
const resultListTable = [
  "Select",
  "Sr. No.",
  "Resume ID",
  "Name",
  "Email",
  "Phone",
  "Candidate Status",
  "Evaluation Status",
  "Marks",
  "WMark",
  "EV Result",
  "Feedback",
  "Evaluation Date",
  "Updated On",
  "Updated By",
  "Comments",
];

function EvaluationDescriptions({
  setView,
  qhjid,
  evid,
  exist,
  evalDesc,
  globalEvaluationPage = false,
}) {
  const [currentView, setCurrentView] = useState("questionset");
  const { getResumesByJD, allApplications, getAllApplicationsByJD } =
    useResumeStore();

  useEffect(() => {
    if (!globalEvaluationPage) {
      getAllApplicationsByJD(qhjid);
    }
  }, []);

  const GetLastUpdated = (appDetail) => {
    if (appDetail.resumestatus.updatedby.timestamp === 0) {
      return {
        updatedBy: appDetail.candidatestatus.updatedby.name,
        updatedOn: appDetail.candidatestatus.updatedby.updatedon,
      };
    } else if (
      appDetail.candidatestatus.updatedby.timestamp >
      appDetail.resumestatus.updatedby.timestamp
    ) {
      return {
        updatedBy: appDetail.candidatestatus.updatedby.name,
        updatedOn: appDetail.candidatestatus.updatedby.updatedon,
      };
    } else {
      return {
        updatedBy: appDetail.resumestatus.updatedby.name,
        updatedOn: appDetail.resumestatus.updatedby.updatedon,
      };
    }
  };

  function getEval(appDetail) {
    var myEval = appDetail?.testevalstatus?.filter(
      (item) => item?.qhevid === evid,
    );
    return myEval?.[0];
  }

  const evData = allApplications?.map((appDetail, idx) => {
    let lUpdate = GetLastUpdated(appDetail);
    let thisEval = getEval(appDetail);
    //console.log("Communications MyEval",thisEval )
    //console.log("Communications Data",appDetail )
    return {
      select: "",
      id: idx + 1,
      qhrid: appDetail?.qhrid,
      name: appDetail?.applicationid.name,
      email: appDetail?.applicationid.email,
      mobile: appDetail?.applicationid.mobile,
      candidateStatus: appDetail?.candidatestatus?.status,
      linksharedon: thisEval != null ? thisEval?.linksentdate : "--",
      numLinks: thisEval != null ? thisEval?.numlinksent : 0,
      linkStatus: thisEval != null ? thisEval?.linkstatus : "--",
      evStatus: thisEval != null ? thisEval?.examstatus : "--",
      dateAdded: thisEval != null ? lUpdate?.updatedOn : "--",
      uploadedBy: thisEval != null ? lUpdate?.updatedBy : "--",
    };
  });

  const examData = allApplications?.map((appDetail, idx) => {
    let lUpdate = GetLastUpdated(appDetail);
    let thisEval = getEval(appDetail);
    //console.log("Communications MyEval",thisEval )
    //console.log("Communications Data",appDetail )
    return {
      select: "",
      id: idx + 1,
      qhrid: appDetail?.qhrid,
      name: appDetail?.applicationid.name,
      email: appDetail?.applicationid.email,
      mobile: appDetail?.applicationid.mobile,
      candidateStatus: appDetail?.candidatestatus?.status,
      evStatus: thisEval != null ? thisEval?.examstatus : "--",
      proctoringStatus: thisEval != null ? thisEval?.examstatus : "--",
      EvDate: thisEval?.takendate != "" ? thisEval?.takendate : "--",
      dateAdded: lUpdate?.updatedOn,
      uploadedBy: lUpdate?.updatedBy,
    };
  });
  const resultData = allApplications?.map((appDetail, idx) => {
    let lUpdate = GetLastUpdated(appDetail);
    let thisEval = getEval(appDetail);
    //console.log("Communications MyEval",thisEval )
    //console.log("Communications Data",appDetail )
    return {
      select: "",
      id: idx + 1,
      qhrid: appDetail?.qhrid,
      name: appDetail?.applicationid.name,
      email: appDetail?.applicationid.email,
      mobile: appDetail?.applicationid.mobile,
      candidateStatus: appDetail?.candidatestatus?.status,
      evStatus: thisEval != null ? thisEval?.examstatus : "--",
      marks: thisEval != null ? thisEval?.totalmarks : "--",
      marksw: thisEval != null ? thisEval?.wmarks : "--",
      evResult: thisEval != null ? thisEval?.resultstatus : "--",
      feedback: thisEval?.feedback != "" ? thisEval?.feedback : "--",
      EvDate: thisEval?.takendate != "" ? thisEval?.takendate : "--",
      dateAdded: lUpdate?.updatedOn,
      uploadedBy: lUpdate?.updatedBy,
      remarks: appDetail?.newemploymentdetails?.otherremarks
        ? appDetail?.newemploymentdetails?.otherremarks
        : "--",
    };
  });

  return (
    <>
      <div className="candidate-description-wrapper">
        <div className="candidate-description-buttons-wrapper">
          <Button
            className={`candidate-description-btn ${
              currentView === "setup" && "candidate-description-btn-active"
            }`}
            onClick={(e) => {
              setCurrentView("setup");
            }}
          >
            Setup
          </Button>
          <Button
            className={`candidate-description-btn ${
              currentView === "questionset" &&
              "candidate-description-btn-active"
            }`}
            onClick={(e) => {
              setCurrentView("questionset");
            }}
          >
            Question Set
          </Button>
          <Button
            className={`candidate-description-btn ${
              currentView === "questionbank" &&
              "candidate-description-btn-active"
            }`}
            onClick={(e) => {
              setCurrentView("questionbank");
            }}
          >
            Question Bank
          </Button>
          {!globalEvaluationPage && (
            <>
              <Button
                className={`candidate-description-btn ${
                  currentView === "candidates" &&
                  "candidate-description-btn-active"
                }`}
                onClick={(e) => {
                  setCurrentView("candidates");
                }}
              >
                Links
              </Button>
              <Button
                className={`candidate-description-btn ${
                  currentView === "exam" && "candidate-description-btn-active"
                }`}
                onClick={(e) => {
                  setCurrentView("exam");
                }}
              >
                Exam Status
              </Button>
              <Button
                className={`candidate-description-btn ${
                  currentView === "results" &&
                  "candidate-description-btn-active"
                }`}
                onClick={(e) => {
                  setCurrentView("results");
                }}
              >
                Results
              </Button>{" "}
            </>
          )}
        </div>
        <Divider />
        {currentView === "setup" ? (
          <EvaluationSetup
            exist={exist}
            qhjid={qhjid}
            ev_id={evid}
            evalDesc={evalDesc}
            globalEvaluationPage={globalEvaluationPage}
          />
        ) : currentView === "questionset" ? (
          <Evaluations
            qhjid={qhjid}
            ev_id={evid}
            evalDesc={evalDesc}
            setView={setView}
            currentView={currentView}
            globalEvaluationPage={globalEvaluationPage}
          />
        ) : currentView === "questionbank" ? (
          <EvaluationsBank
            qhjid={qhjid}
            ev_id={evid}
            evalDesc={evalDesc}
            setView={setView}
            globalEvaluationPage={globalEvaluationPage}
          />
        ) : currentView === "candidates" ? (
          <>
            {evalDesc.state == "Live" ? (
              <EvalCandidateTableSelectable
                titleList={communicationListTable}
                data={evData}
                isEditField={true}
                ev_id={evid}
                qhjid={qhjid}
                currentView={currentView}
              />
            ) : (
              "Candidates cannot be contacted as Evaluation is not active"
            )}
          </>
        ) : currentView === "exam" ? (
          <>
            {evalDesc.state == "Live" ? (
              <EvalCandidateTableSelectable
                selectable={false}
                titleList={examListTable}
                data={examData}
                isEditField={true}
                ev_id={evid}
                qhjid={qhjid}
                currentView={currentView}
              />
            ) : (
              "Candidates cannot be contacted as Evaluation is not active"
            )}
          </>
        ) : currentView === "results" ? (
          <>
            {evalDesc.state == "Live" ? (
              <EvalCandidateTableSelectable
                titleList={resultListTable}
                data={resultData}
                isEditField={true}
                ev_id={evid}
                qhjid={qhjid}
                currentView={currentView}
              />
            ) : (
              "Candidates cannot be contacted as Evaluation is not active"
            )}
          </>
        ) : null}
      </div>
    </>
  );
}

export default EvaluationDescriptions;
